"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSavePrimaryMetadataCreatorsInstruction = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const Creator_1 = require("../types/Creator");
const savePrimaryMetadataCreatorsStruct = new beet.FixableBeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['primaryMetadataCreatorsBump', beet.u8],
    ['creators', beet.array(Creator_1.creatorBeet)],
], 'SavePrimaryMetadataCreatorsInstructionArgs');
const savePrimaryMetadataCreatorsInstructionDiscriminator = [66, 240, 213, 46, 185, 60, 192, 254];
function createSavePrimaryMetadataCreatorsInstruction(accounts, args) {
    const { admin, metadata, primaryMetadataCreators } = accounts;
    const [data] = savePrimaryMetadataCreatorsStruct.serialize({
        instructionDiscriminator: savePrimaryMetadataCreatorsInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: admin,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: metadata,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: primaryMetadataCreators,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('SaLeTjyUa5wXHnGuewUSyJ5JWZaHwz3TxqUntCE9czo'),
        keys,
        data,
    });
    return ix;
}
exports.createSavePrimaryMetadataCreatorsInstruction = createSavePrimaryMetadataCreatorsInstruction;
//# sourceMappingURL=savePrimaryMetadataCreators.js.map